import { BottomSheetBody, BottomSheetHeader, Skeleton } from "@opensea/ui-kit"

export const DropPublishFlowSkeleton = () => {
  return (
    <>
      <BottomSheetHeader title="Loading..." />
      <BottomSheetBody>
        <div className="flex w-full flex-col gap-4">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-4 w-24" />
        </div>
      </BottomSheetBody>
    </>
  )
}
